<template>
<div class="animated fadeIn">
  <div class="row">
    <div class="col-sm-9">
      <table class="table table-foursight table-striped table-hover table-sm">
        <tbody>
          <thead>
            <th colspan="2" class="no-border">{{$t('UPCOMINGSCHEDULE')}}</th>
          </thead>
          <template v-for="item in scheduleSummary">
            <tr>
              <td colspan="2" class="upcoming-schedule">
                {{ moment(item.date).format('ddd-MMM/DD/YY')}}
              </td>
            </tr>
            <template v-for="child in item.children">
              <tr>
                <td>
                  {{child.name}}
                </td>
                <td>
                  {{ moment(moment.utc(child.startTime).toDate()).local().format('hh:mm A')}} to {{moment(moment.utc(child.endTime).toDate()).local().format('hh:mm A')}}
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <div class="col-md-3">
      <aside class="smaller smaller-store">
        <div class="dash-field-dark">
          <h3>{{$t('STOREPROFILE')}}</h3>
        </div>
        <div class="dash-field-smaller">

          <div class="polje-dash polje-dash-user">
            <div class="tekst-dash mb-sm">
              <h4>{{store.name}}</h4>
              <p><small>{{store.address}}<br>
                  {{store.city}}, {{store.province}}, {{store.postalCode}}<br>
                  P: {{store.phoneNumber}}<br><br>

                  <b>{{$t('MANAGER')}}</b><br>
                  {{store.managerName}} <br><br>

                  <b>{{$t('REGIONALMANAGER')}}</b><br>
                  {{store.regionName}} <br>

                  <b>{{$t('DEFAULTOPERATINGHOURS')}}</b><br>
                  <template v-for="item in store.workingTimeOut">
                    {{item.text}} {{item.open}} to {{item.close}} <br>
                  </template><br>

                  <template v-if="store.dateException !== undefined && store.dateException.length > 0">
                  <b>{{$t('DATEEXCEPTION')}}</b><br>
                  <template v-for="item in store.dateException">
                    {{moment.utc(item.date).local().format('YYYY-MM-DD')}} {{moment(moment.utc(item.start).toDate()).local().format('hh:mm A')}} to {{moment(moment.utc(item.end).toDate()).local().format('hh:mm A')}}<br>
                  </template></template></small></p>
            </div>
            <div class="adjust">
              <button type="button" class="btn btn-secondary btn-sm mt-4" @click="showModal(store)" 
                v-if="(globals !== undefined && globals.acl !== undefined && globals.acl.Store && globals.acl.Store.updateAction) ? true : false">{{$t('EDIT')}}</button>
            </div>
          </div>
        </div>
      </aside>
    </div>
  </div>
  <b-modal ref="formmodal" :title="$t('STOREFORM')" ok-title="submit" hide-footer size="xl" no-close-on-backdrop>
    <div class="d-block">
      <storeform v-bind:formData="formData" v-bind:formError="formError" v-bind:province="province" v-bind:users="users"></storeform>
    </div>
    <div class="text-right">
      <b-btn class="mt-3" variant="secondary mr-lg" @click="hideModal">{{$t('CANCEL')}}</b-btn>
      <b-btn class="mt-3" variant="primary" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'

import SchedualApi from '@/api/salesportal/Schedual'
import StoreApi from '@/api/salesportal/Store'
import ProvinceApi from '@/api/salesportal/Province'
import UsersApi from '@/api/admin/Users'
import StoreForm from '../Form'

export default
{
  name: 'RecentActivityWin',
  props: ['storeId', 'tabIndex'],
  components:
  {
    storeform: StoreForm
  },
  data: function()
  {
    return {
      scheduleSummary:
      {},
      store:
      {},
      province:
      {},
      users:
      {},
      formError:
      {},
      formData:
      {
        'provinceId': null,
        'storeManagerId': null,
        'regionalManagerId': null,
        'code': '',
        'name': '',
        'address': '',
        'city': '',
        'postalCode': '',
        'phoneNumber': '',
        'workingTimeOut': [
        {
          text: 'SUNDAY',
          open: '',
          close: ''
        },
        {
          text: 'MONDAY',
          open: '',
          close: ''
        },
        {
          text: 'TUESDAY',
          open: '',
          close: ''
        },
        {
          text: 'WEDNESDAY',
          open: '',
          close: ''
        },
        {
          text: 'THURSDAY',
          open: '',
          close: ''
        },
        {
          text: 'FRIDAY',
          open: '',
          close: ''
        },
        {
          text: 'SATURDAY',
          open: '',
          close: ''
        }]
      }
    }
  },
  created()
  {
    var me = this;
    me.getScheduleSummary();
    me.getStore();
    if(me.globals !== undefined && me.globals.acl !== undefined && me.globals.acl.Store && me.globals.acl.Store.insertAction)
    {
      me.getProvince();
      me.getUsers();
    }
    
  },
  methods:
  {
    async getScheduleSummary()
    {
      var me = this;
      try
      {
        var data = await SchedualApi.getScheduleSummary(
        {
          storeId: me.storeId
        });

        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.scheduleSummary = data.root;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getStore()
    {
      var me = this;
      try
      {
        var data = await StoreApi.selectRow(
        {
          storeId: me.storeId
        });
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.store = data.root[0];
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async getProvince()
    {
      var me = this;
      try
      {
        var data = await ProvinceApi.selectRow();
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.province = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    getUsers()
    {
      var me = this;
      try
      {
        UsersApi.selectActiveUsers(me.getParams, function(data)
        {
          if (data.error && data.error == true)
          {
            me.$notify.notice(data);
            return;
          }

          for (var i = 0; i < data.root.length; i++)
          {
            data.root[i].password = '';
            data.root[i].trhidden = false;
          }

          me.users = data;
        });
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined') me.formData = item;
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        if (typeof item.storeId != 'undefined')
        {
          item.id = item.storeId;
          delete(item.storeId);
        }

        var data = await StoreApi.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getStore();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        'provinceId': null,
        'storeManagerId': null,
        'regionalManagerId': null,
        'code': '',
        'name': '',
        'address': '',
        'city': '',
        'postalCode': '',
        'phoneNumber': '',
        'workingTimeOut': [
        {
          text: 'SUNDAY',
          open: '',
          close: ''
        },
        {
          text: 'MONDAY',
          open: '',
          close: ''
        },
        {
          text: 'TUESDAY',
          open: '',
          close: ''
        },
        {
          text: 'WEDNESDAY',
          open: '',
          close: ''
        },
        {
          text: 'THURSDAY',
          open: '',
          close: ''
        },
        {
          text: 'FRIDAY',
          open: '',
          close: ''
        },
        {
          text: 'SATURDAY',
          open: '',
          close: ''
        }]
      }
    }
  },
  watch:
  {
    async tabIndex(val)
    {
      var me = this;
      try 
      {
        if(val == 0)
        {
          await me.getScheduleSummary();
          await me.getStore();
          await me.getProvince();
          await me.getUsers();
        } 
      } 
      catch (error) 
      {
        me.$notify.notice(e);
      }           
    }
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
